module.exports = __webpack_public_path__ + "static/media/Caratula_DISH_ON_447-2025.b68ca312.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Caratula_DISH_ON_447-2025.pdf
// module id = 361
// module chunks = 0